<h2 mat-dialog-title>Destinatários do alerta</h2>

<mat-dialog-content>
    <p class="texto-apoio">Estas pessoas recebem um e-mail quando a atualização automática falhar.</p>

    <div class="adicionar-email">
        <mat-form-field appearance="outline">
            <mat-label>Adicionar e-mail</mat-label>
            <input matInput type="email" [formControl]="emailControl" placeholder="nome@atsinformatica.com.br"
                (keydown.enter)="$event.preventDefault(); adicionar()" (input)="erroEmail = null" />
            @if (erroEmail) {
                <mat-hint class="texto-erro">{{ erroEmail }}</mat-hint>
            }
        </mat-form-field>
        <button type="button" mat-button class="btn-secundary" (click)="adicionar()">
            <span class="material-symbols-outlined">add</span> Adicionar
        </button>
    </div>

    <div class="lista-email">
        @for (email of listaEmail; track email) {
            <div class="linha-email">
                <span>{{ email }}</span>
                <button type="button" mat-icon-button matTooltip="Remover" aria-label="Remover" (click)="remover(email)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        }
        @if (listaEmail.length === 0) {
            <p class="texto-erro">Adicione ao menos 1 destinatário para salvar.</p>
        }
    </div>

    <mat-checkbox [(ngModel)]="isAvisarRetorno">Avisar também quando a API voltar a funcionar</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
    <button type="button" mat-flat-button class="btn-secundary" [disabled]="isSalvando" (click)="cancelar()">Cancelar</button>
    <button type="button" mat-flat-button class="btn-primary" [disabled]="listaEmail.length === 0 || isSalvando" (click)="salvar()">
        @if (isSalvando) {
            <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
        } @else {
            Salvar
        }
    </button>
</mat-dialog-actions>
